import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
@Component({
    selector: 'app-loader',
    template: `
    <div *ngIf="isLoading" class="loader-container">
      <div class="spinner"></div>
    </div>
  `,
    styles: [`
    .loader-container {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 15px;
      margin-top: 100px;
    }

    .spinner {
      width: 200px; /* Larger loader size */
      height: 200px;
      border: 20px solid rgba(0, 0, 0, 0.1);
      border-top: 20px solid #cf1f25; /* Bootstrap primary color */
      border-radius: 200%;
      animation: spin 1s linear infinite;
    }

    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `],
    imports: [
        CommonModule
    ]
})
export class LoaderComponent {
  @Input() isLoading = false;
}
